export default __webpack_public_path__ + "static/media/03_SMART_X_CONNECT.adb3237a.jpg";